exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n* DEFINE VARIABLES\n*/\n.subHeader[data-v-72de9e7c] {\n  margin-top: 3px;\n}\n.group-button-sub-header[data-v-72de9e7c] {\n  float: right;\n  top: 120px;\n  margin: 65px 30px 0 0;\n}\n.content-header[data-v-72de9e7c] {\n  width: 250px;\n}\n.float-left[data-v-72de9e7c] {\n  float: left;\n}\n.float-right[data-v-72de9e7c] {\n  float: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72de9e7c","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/subHeaders/SubHeaderUserManagement.vue
// module id = 2023
// module chunks = 1